export default "__VITE_ASSET__BLvyYQ5H__"